import { BookOpen, Download, LogIn, Notebook, LayoutGrid } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
import { useI18n } from '../i18n';

const items = [
  { to: '/trainer', label: 'trainer_home_start', icon: LayoutGrid, end: true },
  { to: '/training-library/exercises', label: 'trainer_exercises', icon: BookOpen },
  { to: '/training-library/plans', label: 'trainer_plans', icon: Notebook },
  { to: '/trainer/offline', label: 'trainer_home_offline_short', icon: Download },
  { to: '/login', label: 'login_title', icon: LogIn },
] as const;

export default function PublicTrainerNavigation({ inlineOnWide = false }: { inlineOnWide?: boolean }) {
  const { t, locale } = useI18n();
  const path = useLocation().pathname.replace(/^\/(nl|en)(?=\/|$)/, '');
  return (
    <nav aria-label={t('trainer_home_navigation')} className={`fixed inset-x-0 bottom-0 z-40 border-t border-gray-200 bg-white/95 pb-[env(safe-area-inset-bottom)] backdrop-blur ${inlineOnWide ? 'lg:static lg:border-b lg:border-t-0 lg:pb-0' : ''}`}>
      <div className={`mx-auto grid h-16 max-w-lg grid-cols-5 px-1 ${inlineOnWide ? 'lg:flex lg:h-auto lg:max-w-[1440px] lg:gap-4 lg:px-6' : ''}`}>
        {items.map(item => {
          const { to, label, icon: Icon } = item;
          const active = path === to || (!('end' in item) && path.startsWith(`${to}/`));
          return <Link
            key={to}
            to={`/${locale}${to}`}
            aria-current={active ? 'page' : undefined}
            className={`flex min-w-0 flex-col items-center justify-center gap-1 px-1 text-[11px] font-medium leading-none ${inlineOnWide ? 'lg:min-h-12 lg:flex-row lg:gap-2 lg:px-3 lg:text-sm' : ''} ${active ? 'text-primary-700' : 'text-gray-500'}`}
          >
            <Icon size={21} aria-hidden="true" />
            <span className="truncate">{t(label)}</span>
          </Link>;
        })}
      </div>
    </nav>
  );
}
